import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../service/main/auth.service';
import { SettingsService } from '../../service/common/settings.service';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AddLotService } from '../../service/main/add-lot.service';
import { ToastrService } from '../../service/common/toastr.service';
import { Select2OptionData } from 'ng2-select2';
import { AgmMap } from '@agm/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'util';
import Enums from '../../utils/enums';
import { NgForm } from '@angular/forms';
import { ParkingsService } from '../../service/main/parkings.service';
import { RegisterParking, Company, Tariff, PublicInstitution, RegisterParkingLot, ParkingLot, Scheduler } from '../../entity';


@Component({
    selector: 'app-add-lot',
    templateUrl: './add-lot.component.html',
    styleUrls: ['./add-lot.component.css']
})

export class AddLotComponent implements OnInit {
    parking: RegisterParking = new RegisterParking();
    parkingLots: Array<ParkingLot> = new Array<ParkingLot>();
    generatedLots: Array<RegisterParkingLot> = new Array<RegisterParkingLot>();
    isEdit: boolean = false;

    companyList: Array<any>;
    publicInstitutionList: Array<any>;

    lat = null;
    lng = null;
    zoom = 13;
    showMap: boolean = false;
    currencyTypePerDay: number = Enums.eCurrencyType.RON;
    currencyTypePerHour: number = Enums.eCurrencyType.RON;
    parkingLevelID: number = Enums.eParkingLevel.Surface;
    checkInstitution: any;

    checkScheduler: any;
    isAllDay: boolean = false;
    totalParkingLotsNumber: number = 0;
    hasSensors: boolean = false;

    company: Company = {
        CompanyID: null,
        Title: null
    };

    publicInstitution: PublicInstitution = {
        PublicInstitutionID: null,
        Title: null
    };

    //check if institution is public or private
    institutions = [
        {
            value: Enums.eParkingType.Public,
            display: 'Public'
        },
        {
            value: Enums.eParkingType.Private,
            display: 'Private'
        }
    ];
    //check if scheduler is standard or per day
    schedulers = [
        {
            value: Enums.eSchedulerType.Standard,
            display: 'Standard'
        },
        {
            value: Enums.eSchedulerType.Daily,
            display: 'Per days'
        }
    ];

    //#region 
    tariffPerHour: string;
    tariffPerDay: string;
    prefix: string;
    padding: string;
    suffix: string;
    start: string;
    end: string;
    //#endregion

    constructor(private authService: AuthService,
        private settings: SettingsService,
        private http: Http,
        private addLotService: AddLotService,
        private toastr: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
        private parkingService: ParkingsService,
    ) { }

    ngOnInit() {
        navigator.geolocation.getCurrentPosition(position => {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;
        });
        this.checkInstitution = {
            isPrivate: this.institutions[1].value
        };
        this.checkScheduler = {
            isStandard: this.schedulers[0].value
        };
    }

    showPreview(event): void {
        const fileList: FileList = event.target.files;
        const file: File = fileList[0];
        if (fileList && file) {
            if (file.size > 250000) {
                const input: any = document.getElementById('choose-file');
                input.value = '';
                return;
            }

            const reader = new FileReader();
            reader.onload = function (e: any) {
                const src = e.target.result;
                const image = document.getElementById('preview-image').setAttribute('src', src);
            };

            reader.readAsDataURL(file);
        }
    }

    setEntrancePosition($event): void {
        this.parking.Latitude = $event.coords.lat;
        this.parking.Longitude = $event.coords.lng;
    }

    submitParkingForm(event, form: NgForm): void {
        var tariffs = new Array<Tariff>();
        var tariffPerHour = new Tariff(
            Enums.eTariffType.Standard,
            Number(form.value.currencyTypePerHour),
            form.value.tariffPerHour
        );
        tariffs.push(tariffPerHour);

        var tariffPerDay = new Tariff(
            Enums.eTariffType.PerDay,
            Number(form.value.currencyTypePerDay),
            form.value.tariffPerDay
        );
        tariffs.push(tariffPerDay);

        this.parking = new RegisterParking(
            this.checkInstitution.isPrivate,
            Number(form.value.parkingLevelID),
            this.company.CompanyID,
            this.publicInstitution.PublicInstitutionID,
            form.value.title,
            form.value.phone,
            form.value.email,
            form.value.address,
            form.value.location,
            form.value.latitude,
            form.value.longitude,
            !form.value.hasSensors ? this.totalParkingLotsNumber : this.parking.SensorLotList.length,
            form.value.hasSensors,
            form.value.ownerName,
            form.value.ownerPhone,
            form.value.ownerEmail,
            form.value.contactName,
            form.value.contactPhone,
            form.value.contactEmail,
            !form.value.hasSensors ? this.generatedLots : [],
            form.value.hasSensors ? this.getSensorsInfo() : [],
            tariffs,
            this.getParkingScheduler(form)
        );

        this.addLotService.addParking(this.parking).subscribe(res => {
            form.reset();
            this.toastr.success('Parking lot successfully added.');
            this.router.navigate(['parking-lots']);

            this.uploadImage(res, event);
        }, err => {
            this.toastr.error('A error has occurred while adding the parking lot.');
        });
    }

    uploadImage(parking, uploadEvent) {
        const parkingID = parking.parkingID;
        const fileList: FileList = uploadEvent.target['0'].files;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            const formData: FormData = new FormData();
            formData.append('uploadedFile', file, file.name);

            this.addLotService.uploadParkingImage(formData, parkingID).subscribe(result => {
            }, error => {
                this.toastr.error('A error has occurred while adding the photo.');
            });
        }
    }

    searchCompany(event): void {
        this.addLotService.searchCompany(event).subscribe(response => {
            if (response && response.length) {
                let companies = new Array<any>();
                response.forEach(item => {
                    companies.push({
                        id: item.companyID,
                        text: item.title
                    });
                });
                this.companyList = companies;
            }
        });
    }

    selectedCompany(event): void {
        this.company.CompanyID = event.id;
        this.publicInstitution.PublicInstitutionID = null;
    }

    searchPublicInstitution(event): void {
        this.addLotService.searchInstitution(event).subscribe(response => {
            if (response && response.length) {
                let publicInstitutions = new Array<any>();
                response.forEach(item => {
                    publicInstitutions.push({
                        id: item.publicInstitutionID,
                        text: item.title
                    })
                });
                this.publicInstitutionList = publicInstitutions;
            }
        });
    }

    selectedPublicInstitution(event): void {
        this.publicInstitution.PublicInstitutionID = event.id;
        this.company.CompanyID = null;
    }

    toggleMap(): void {
        this.showMap = !this.showMap;
    }

    generateLot(form: NgForm): void {
        if (form.valid) {
            this.totalParkingLotsNumber += form.value.end - form.value.start + 1;
            let generateLot = new RegisterParkingLot(
                form.value.prefix,
                form.value.suffix,
                form.value.padding,
                form.value.start,
                form.value.end
            );
            this.generatedLots.push(generateLot);
            form.reset();
        }
    }

    deleteLot(index): void {
        this.totalParkingLotsNumber -= this.generatedLots[index].End - this.generatedLots[index].Start + 1;
        this.generatedLots.splice(index, 1);
    }

    getParkingScheduler(form): Array<Scheduler> {
        let schedulers = new Array<Scheduler>();
        if (form.value.schedulerType === Enums.eSchedulerType.Standard) {
            let scheduler = new Scheduler(
                form.value.schedulerType,
                form.value.workingHoursStart,
                form.value.workingHoursEnd,
                this.isAllDay,
                null
            );
            schedulers.push(scheduler);
        } else if (form.value.schedulerType === Enums.eSchedulerType.Daily) {
            schedulers = [
                new Scheduler(
                    form.value.schedulerType,
                    form.value.mondayStart,
                    form.value.mondayEnd,
                    this.isAllDay,
                    Enums.eDayOfWeek.Monday
                ),
                new Scheduler(
                    form.value.schedulerType,
                    form.value.tuesdayStart,
                    form.value.tuesdayEnd,
                    this.isAllDay,
                    Enums.eDayOfWeek.Tuesday
                ),
                new Scheduler(
                    form.value.schedulerType,
                    form.value.wednesdayStart,
                    form.value.wednesdayEnd,
                    this.isAllDay,
                    Enums.eDayOfWeek.Wednesday
                ),
                new Scheduler(
                    form.value.schedulerType,
                    form.value.thursdayStart,
                    form.value.thursdayEnd,
                    this.isAllDay,
                    Enums.eDayOfWeek.Thursday
                ),
                new Scheduler(
                    form.value.schedulerType,
                    form.value.fridayStart,
                    form.value.fridayEnd,
                    this.isAllDay,
                    Enums.eDayOfWeek.Friday
                ),
                new Scheduler(
                    form.value.schedulerType,
                    form.value.saturdayStart,
                    form.value.saturdayEnd,
                    this.isAllDay,
                    Enums.eDayOfWeek.Saturday
                ),
                new Scheduler(
                    form.value.schedulerType,
                    form.value.sundayStart,
                    form.value.sundayEnd,
                    this.isAllDay,
                    Enums.eDayOfWeek.Sunday
                )
            ];
        }
        return schedulers;
    }

    //#region Sensors
    addSensor(event): void {
        let parkingLot = new ParkingLot(
            null,
            event.coords.lat,
            event.coords.lng,
            false,
            null,
            true,
            true,
            false,
        );
        this.parkingLots.push(parkingLot);
    }

    removeSensor(index): void {
        this.parkingLots.splice(index, 1);
    }

    changeSensorPosition(event, index): void {
        this.parkingLots[index].Latitude = event.coords.lat;
        this.parkingLots[index].Longitude = event.coords.lng;
    }

    setSensorID(value, index, event): void {
        if (event.keyCode == 13) {
            this.parkingLots[index].SensorRegistrationNumber = value;
            this.parkingLots[index].IsIdEditable = false;
        }
    }

    editSensorID(index): void {
        this.parkingLots[index].IsIdEditable = true;

    }

    setSensorNO(value, index, event): void {
        if (event.keyCode == 13) {
            this.parkingLots[index].No = value;
            this.parkingLots[index].IsNoEditable = false;
        }
    }

    editSensorNO(index): void {
        this.parkingLots[index].IsNoEditable = true;
    }

    getSensorPin(index): string {
        if (!this.parkingLots[index].IsSelected) {
            return '../../../assets/sensors/sensor-pin.png';
        } else {
            return '../../../assets/sensors/selected-sensor-pin.png';
        }
    }

    selectSensor(index): void {
        this.parkingLots.forEach((sensor, current) => {
            if (current == index) {
                sensor.IsSelected = true;
            } else {
                sensor.IsSelected = false;
            }
        });
    }

    getSensorsInfo(): Array<ParkingLot> {
        let parkingLots: Array<ParkingLot> = [];
        this.parkingLots.forEach(sensor => {
            if (sensor.SensorRegistrationNumber != null && sensor.No != null) {
                let parkingLot = new ParkingLot(
                    sensor.No,
                    sensor.Latitude,
                    sensor.Longitude,
                    sensor.IsHandicapped,
                    sensor.SensorRegistrationNumber,
                    null,
                    null,
                    null
                );
                parkingLots.push(parkingLot);
            }
        });
        return parkingLots;
    }

    setHandicap(value, index): void {
        this.parkingLots.forEach((sensor, current) => {
            if (index == current) {
                sensor.IsHandicapped = value;
            }
        });
    }
    //#endregion

    //#region Obsolete
    // private cancelEdit(): void {
    //   if (this.isEdit) {
    //     this.router.navigate(['parking-lots/', + this.parking.ParkingID]);
    //   } else {
    //     this.router.navigate(['parking-lots']);
    //   }
    // }

    // private getLoadedSensors(loadedSensors): Array<Object> {
    //   let sensors: Array<Object> = [];
    //   for (let sensor of loadedSensors) {
    //     sensors.push({
    //       id: sensor.sensorRegistrationNumber,
    //       no: sensor.no,
    //       lat: sensor.latitude,
    //       lng: sensor.longitude,
    //       isIdEditable: false,
    //       isNoEditable: false,
    //       isSelected: false,
    //       isHandicapped: sensor.isHandicapped,
    //       editStateID: Enums.eSensorEditState.Unedited,
    //       parkingLotID: sensor.parkingLotID,
    //       sensorID: sensor.sensorID,
    //     });
    //   }
    //   return sensors;
    // }

    // private getMarkerDisplayState(index): boolean {
    //   let display: boolean = true;
    //   this.parking.sensors.forEach((sensor, current) => {
    //     if (index == current && sensor.editStateID == Enums.eSensorEditState.Removed) {
    //       display = false;
    //     }
    //   });
    //   return display;
    // }

    // private getLoadedParkingScheduler(schedulers): Array<Object> {
    //   this.isAllDay = schedulers[0].isAllDay;
    //   let sched: Array<Object> = schedulers;
    //   if (schedulers[0].schedulerTypeID == Enums.eSchedulerType.Standard) {
    //     for (let i = 0; i <= 5; i++) {
    //       sched.push({
    //         hourFrom: null,
    //         hourTo: null,
    //       });
    //     }
    //   }
    //   return sched;
    // }

    // private getModifiedSensorsList(): Array<Object> {
    //   let lots: Array<Object> = [];
    //   this.parking.sensors.forEach(sensor => {
    //     if (sensor.id != null && sensor.no != null) {
    //       if (sensor.editStateID == Enums.eSensorEditState.New) {
    //         lots.push({
    //           no: sensor.no,
    //           sensorRegistrationNumber: sensor.id,
    //           latitude: sensor.lat,
    //           longitude: sensor.lng,
    //           isHandicapped: Number(sensor.isHandicapped),
    //           parkingLotSensorStateID: sensor.editStateID,
    //         });
    //       } else {
    //         lots.push({
    //           no: sensor.no,
    //           sensorRegistrationNumber: sensor.id,
    //           latitude: sensor.lat,
    //           longitude: sensor.lng,
    //           isHandicapped: Number(sensor.isHandicapped),
    //           parkingLotID: sensor.parkingLotID,
    //           parkingLotSensorStateID: sensor.editStateID,
    //           sensorID: sensor.sensorID
    //         });
    //       }
    //     }
    //   });
    //   return lots;
    // }


    // private generateFakeScheduler(): Array<Object> {
    //   let scheduler: Array<Object> = [];
    //   for (let i = 0; i <= 6; i++) {
    //     scheduler.push({
    //       hourFrom: null,
    //       hourTo: null,
    //     });
    //   }
    //   console.log(scheduler);
    //   return scheduler;
    // }
    //#endregion
}
